import { uiAmountToLamports } from "@bridgesplit/utils";
import { VaultMintLpParams } from "@bridgesplit/abf-sdk";

import { LoopWinder, LoopWinderCtx, WindQuoteTarget } from "./types";
import { BaseWinder } from "./BaseWinder";

export class LpWinder extends BaseWinder implements LoopWinder {
    readonly name = "LpWinder";
    readonly windQuoteTarget: WindQuoteTarget = "markets";

    constructor(isPrincipalWind = false) {
        super(isPrincipalWind);
    }

    buildWindQuoteParams(ctx: LoopWinderCtx): VaultMintLpParams | undefined {
        const { loopExpanded, quote } = ctx;

        if (!loopExpanded || !quote?.principalAmount) return undefined;

        const principalAmountLamports = uiAmountToLamports(quote.principalAmount, loopExpanded.principalToken.decimals);

        // TODO: Calculate minLpAmount based on slippage once we have LP pricing
        const minLpAmount = 0;

        return {
            vault: loopExpanded.vaultIdentifier,
            principalAmount: principalAmountLamports,
            minLpAmount
        };
    }
}
